import React, {useState} from "react";
import {withRouter} from 'react-router-dom';
import {v4 as uuidv4} from 'uuid';
import Loader from "react-loader-spinner";
import {GENERIC_ERROR, SEARCH_FIELDS} from "../../AppConstants";
import * as searchFormValidation from "../../utils/SearchFormValidation";
import ErrorBoundary from "../../ErrorBoundary";
import NameSearch from "./NameSearch";
import OtherQuickSearch from './OtherQuickSearch';
import {setDetailsScreenIds} from '../../actions';
import {authorizeToken} from "../../auth/Authorization";
import {getAppBasePath} from "../../utils/CommonUtility";
import store from "../../store";

import {
  CAlert,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CContainer
} from '@coreui/react'

import MaterialTable from "material-table";
import {forwardRef} from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref}/>),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref}/>),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref}/>),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref}/>),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref}/>),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref}/>),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref}/>),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref}/>),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref}/>),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref}/>),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref}/>),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref}/>),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref}/>)
};

const Dashboard = (props) => {

  const [loading, isLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchKey, setSearchKey] = useState("EMAIL");
  const [quickSearchData, setQuickSearchData] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [message, setMessage] = useState(null);
  const [validationError, setValidationError] = useState(null);
  const [nameSearch, setNameSearch] = useState(false);

  const handleSearchValue = (event) => {
    setSearchValue(event.target.value);
  }

  const handleSearchKey = (option) => {
    setSearchValue("");
    reInitialize();
    setSearchKey(option);

    if ("NAME" === option) {
      setNameSearch(true);
    } else {
      setNameSearch(false);
    }
  }

  const fetchQuickSearchJSON = async (requestOptions) => {
    const response = await fetch(
      process.env.REACT_APP_LEASE_LOOKUP_URL
      , requestOptions
      , {withCredentials: true}
    );
    if (response.status === 404) {
      return [];
    }
    if (!response.ok) {
      console.log('Non-success response:', response);
      throw new Error(`An error has occurred: ${response.status}`);
    }
    const responseJSON = await response.json();
    return responseJSON;
  }

  const fetchData = () => {
    isLoading(true);

    let searchRequest = {
      'merchantName': store.getState()?.userSession?.merchant,
      'searchKey': searchKey,
      'searchValue': searchValue
    }

    let requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-request-id': uuidv4()
      },
      body: JSON.stringify(searchRequest)
    };

    console.log(`Form submitted with requestOptions: ${JSON.stringify(
      requestOptions)}`);

    fetchQuickSearchJSON(requestOptions)
    .then(result => {
      setQuickSearchData(result);
      setShowSearchResults(true);
      isLoading(false);
    }).catch((error) => {
      setMessage(GENERIC_ERROR);
      setShowSearchResults(false);
      isLoading(false);
    });
  }

  const reInitialize = () => {
    setValidationError(null);
    setMessage(null);
    setShowSearchResults(false);
    setQuickSearchData([]);
  }

  const handleSearch = () => {
    reInitialize();

    if (store.getState()?.userSession == null
      || store.getState()?.userSession?.token == null) {
      window.location.replace(getAppBasePath());
    }

    let error = searchFormValidation.fieldValidation(searchKey, searchValue);
    if (error != null) {
      setValidationError(error);
      return;
    }

    authorizeToken()
    .then(response => {
      fetchData();
    })
    .catch(error => {
      console.log("invalid token!")
      window.location.replace(getAppBasePath());
    });

  }

  const showDetails = (event, rowData) => {
    const {loan, loanApplication, user} = rowData;
    store.dispatch(setDetailsScreenIds({
      'userId': user?.id,
      'loanApplicationId': loanApplication?.id,
      'loanId': loan?.id,
      'outgoingPaymentId': loan?.outgoing_payment_id,
      'loanState': loan?.state,
      'applicationNumber': loanApplication?.order?.applicationNumber,
      'lesseeName': user ? user.first_name + ' ' + user.last_name : ""
    }));

    props.history.push({pathname: "/details"});
  }

  return (
    <ErrorBoundary>
      <CContainer className="search">
        <div className="pageTitle">Quick Search</div>
        <CRow>
          <CCol sm="4">
            <CCard>
              <CCardBody>
                <CRow>
                  <CCol sm="5">
                    <div className="small text-muted">Search Customer By:</div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CDropdown className="mt-2">
                      <CDropdownToggle caret className="btn-block">
                        {searchKey.replace("_", " ")}
                      </CDropdownToggle>
                      <CDropdownMenu>
                        {SEARCH_FIELDS.map(item =>
                          <CDropdownItem key={item.key}
                                         name={item.value}
                                         onClick={() => handleSearchKey(
                                           item.key)}>{item.value}</CDropdownItem>
                        )}
                      </CDropdownMenu>

                    </CDropdown>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
          <CCol>
            {nameSearch ? <NameSearch {...props} fetchData={fetchData}
                                      reInitialize={reInitialize}
                                      setSearchValue={setSearchValue}
                                      setValidationError={setValidationError}
                                      validationError={validationError}/>
              : <OtherQuickSearch handleSearch={handleSearch}
                                  searchValue={searchValue}
                                  validationError={validationError}
                                  handleSearchValue={handleSearchValue}/>
            }
          </CCol>
        </CRow>

        {message &&
        <CAlert color="danger" closeButton>
          {message}
        </CAlert>
        }

        {loading && <Loader type="ThreeDots" color="#A6A7AD" height={50}
                            width={50}/>}

        {showSearchResults &&
        <CCard>
          <CCardBody>
            <CRow>
              <CCol>
                <MaterialTable icons={tableIcons}
                               title="Quick Search Results"
                               data={quickSearchData}
                               onRowClick={showDetails}
                               columns={[
                                 {
                                   field: 'loanApplication.createdAt',
                                   type: 'datetime',
                                   title: 'Application Date'
                                 },
                                 {
                                   field: 'user.first_name',
                                   title: 'First Name'
                                 },
                                 {
                                   field: 'user.last_name',
                                   title: 'Last Name'
                                 },
                                 {
                                   field: 'loanApplication.order.applicationNumber',
                                   title: 'Application Number'
                                 },
                                 {
                                   field: 'loanApplication.order.orderNumber',
                                   title: 'Order Number'
                                 },
                                 {
                                   field: 'loanApplication.state',
                                   title: 'Application Status'
                                 },
                                 {
                                   field: 'loan.state',
                                   title: 'Lease Status'
                                 }
                               ]}
                               options={{
                                 search: true,
                                 paging: true,
                                 exportButton: false,
                                 headerStyle: {
                                   maxWidth: 15,
                                   fontWeight: 'bold',
                                   fontSize: 12,
                                   height: 10,
                                   maxHeight: 10,
                                   textOverflow: "ellipsis",
                                   overflow: "hidden"
                                 },
                                 searchFieldStyle: {
                                   maxWidth: 200,
                                   fontSize: 10,
                                   height: 20,
                                   maxHeight: 20
                                 },
                                 cellStyle: {
                                   fontSize: 12,
                                   height: 10,
                                   maxHeight: 20,
                                   textTransform: "capitalize",
                                   textOverflow: "ellipsis",
                                   overflow: "hidden"
                                 }
                               }}/>
              </CCol>
            </CRow>

          </CCardBody>
        </CCard>
        }

      </CContainer>
    </ErrorBoundary>
  )
}

export default withRouter(Dashboard);
